import { render, staticRenderFns } from "./FieldsList.vue?vue&type=template&id=7a0fefc2"
import script from "./FieldsList.vue?vue&type=script&setup=true&lang=js"
export * from "./FieldsList.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports